export default "__VITE_ASSET__ba5b62b9__"